import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { faqs } from '@/mocks/homeData';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  const toggle = (idx: number) => setOpen((cur) => (cur === idx ? null : idx));

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <SectionHeading
            centered
            eyebrow="常见问题"
            title="关于入口与最新地址，你可能想问"
            desc="以下问题围绕入口类型、地址变化与防走失方法展开，点击即可展开查看完整回答。"
          />

          <div className="space-y-3">
            {faqs.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={item.q}
                  className="rounded-lg border border-background-200 bg-background-100 overflow-hidden"
                >
                  <button
                    type="button"
                    onClick={() => toggle(idx)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-start gap-3">
                      <span className="flex-shrink-0 font-heading text-sm font-bold text-accent-600">
                        Q{idx + 1}
                      </span>
                      <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                        {item.q}
                      </span>
                    </span>
                    <i
                      className={`flex-shrink-0 text-xl text-primary-700 transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      } ri-arrow-down-s-line`}
                    ></i>
                  </button>
                  {isOpen ? (
                    <div className="px-5 pb-5 pl-14">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}